let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Opl2l")).then(() => parcelRequire('ixj8r'));